import Icon from "@lib/common/components/Icon/Icon";
import { ActionIcon, Group, Paper, Text, Tooltip } from "@mantine/core";

export type ChatAttachmentChipItem = {
  key: string;
  name: string;
  kind: "document" | "report";
  // Owns its own removal so the list doesn't need to re-derive "which underlying file/report is
  // this chip" from the display key. Omitted (e.g. read-only history chips) hides the remove button.
  onRemove?: () => void;
};

export default function ChatAttachmentChips({ items }: { items: ChatAttachmentChipItem[] }) {
  if (items.length === 0) {
    return null;
  }
  return (
    <Group gap="xs" wrap="wrap" mt={5}>
      {items.map(item => (
        <Paper
          key={item.key}
          variant="light"
          color="gray"
          pl="xs"
          px={item.onRemove ? undefined : "xs"}
          pr={item.onRemove ? 5 : undefined}
          py={3}
          bg="var(--mantine-color-gray-light)"
          radius="md"
          shadow="xxs"
        >
          <Group justify="space-between" gap="0" wrap="nowrap">
            <Group gap="xs" wrap="nowrap" style={{ minWidth: 0 }}>
              <Icon
                name={item.kind === "report" ? "file-lines" : "paperclip"}
                size="0.8rem"
                variant="solid"
                color={item.kind === "report" ? "gray" : "red"}
              />
              <Text size="xs" fw={500} style={{ overflowWrap: "anywhere" }}>
                {item.name}
              </Text>
            </Group>

            {item.onRemove && (
              <Tooltip label="Remove attachment">
                <ActionIcon size="sm" variant="subtle" color="gray" radius="md" ml={5} onClick={item.onRemove}>
                  <Icon name="xmark" size="0.8rem" variant="solid" />
                </ActionIcon>
              </Tooltip>
            )}
          </Group>
        </Paper>
      ))}
    </Group>
  );
}
